import { gql } from '@apollo/client';

export const StartParkingSessionMutation = gql`
  mutation StartParkingSessionMutation(
    $gateId: ID!
    $parkingId: ID!
    $userId: ID!
  ) {
    startParkingSession(
      gateId: $gateId
      parkingId: $parkingId
      userId: $userId
    ) {
      id
      startedAt
      endedAt
      gate {
        id
      }
      parking {
        id
      }
      user {
        id
        email
      }
    }
  }
`;
